import AirModalTitlebar from './AirModalTitlebar';

export default AirModalTitlebar;



// WEBPACK FOOTER //
// ./src/common/components/AirModalTitlebar/index.js